/*
 * this file contains the mapping rules between event types &
 * umbraco base card templates.
 */

import React from "react";

// Templates
import ActivitySliderCard from "./templates/ActivitySliderCard/";
import AddProductCard from "./templates/AddProductCard";
import AddSofaShieldCard from "./templates/AddSofaShieldCard/";
import BasketCard from "./templates/BasketCard";
import CancelledOrderCard from "./templates/CancelledOrderCard";
import ConfirmOrderCard from "./templates/ConfirmOrderCard";
import DeliveryBookedCard from "./templates/DeliveryBookedCard";
import DeliveryBookingCard from "./templates/DeliveryBookingCard";
import DeliveryInfoCard from "./templates/DeliveryInfoCard";
import DeliveryInstructionsCard from "./templates/DeliveryInstructionsCard";
import DeliveryNoticeCard from "./templates/DeliveryNoticeCard";
import DetailsConfirmCard from "./templates/DetailsConfirmCard/";
import ErrorCard from "./templates/ErrorCard";
import FlowCard from "./templates/FlowCard";
import HtmlCard from "./templates/HtmlCard";
import MarketingCard from "./templates/MarketingCard";
import OrderDeliveredCard from "./templates/OrderDeliveredCard";
import OrderSummaryCard from "./templates/OrderSummaryCard";
import PayBalanceCard from "./templates/PayBalanceCard";
import RecommendAFriendCard from "./templates/RecommendAFriendCard/";
import SofaRescueBookingCard from "./templates/SofaRescueBookingCard";
import UserDetailsCard from "./templates/UserDetailsCard/";

/**
 * special cases is a list of cardnames (found in props.thisCardName)
 * that can be used to apply a different template to an umbraco dataType
 * but should be used only in special circumstances to avoid hard coding
 * otherwise obfuscated template behavior
 */
export const SPECIAL_CASES = {
  MarketingCard: {
    HtmlCard: {
      matches(str) {
        return this.cases.some((c) => c === str);
      },
      cases: ["HtmlCard"],
    },
    DeliveryNoticeCard: {
      matches(str) {
        return this.cases.some((c) => c === str);
      },
      cases: ["DeliveryTomorrow", "DeliveryToday", "ECRM7WeekAwayv2"],
    },
  },
};

/**
 * Object Properties in CARD_REGISTER directly map to umbraco card names (template)
 *
 * all values must be of type function for the event feed to map together and pass in the props
 * therefore a class or container componant will need to be wrapped
 * in a function that returns its jsx form.
 *
 */
const CARD_REGISTER = {
  ErrorCard,
  MarketingCard: (props) => {
    if (
      SPECIAL_CASES.MarketingCard.DeliveryNoticeCard.matches(props.thisCardName)
    ) {
      return <DeliveryNoticeCard {...props} />;
    }
    if (SPECIAL_CASES.MarketingCard.HtmlCard.matches(props.thisCardName)) {
      return <HtmlCard {...props} />;
    }
    return <MarketingCard {...props} />;
  },
  DeliveryInfoCard: (props) => <DeliveryInfoCard {...props} />,
  DeliveryBookingCard: (props) => <DeliveryBookingCard {...props} />,
  SofaRescueBookingCard: (props) => <SofaRescueBookingCard {...props} />,
  OrderSummaryCard: (props) => <OrderSummaryCard {...props} />,
  ConfirmOrderCard: (props) => <ConfirmOrderCard {...props} />,
  CancelledOrderCard: (props) => <CancelledOrderCard {...props} />,
  DeliveryBookedCard: (props) => <DeliveryBookedCard {...props} />,
  PayBalanceCard: (props) => <PayBalanceCard {...props} />,
  AddProductCard: (props) => <AddProductCard {...props} />,
  AddSofaShieldCard: (props) => <AddSofaShieldCard {...props} />,
  FlowCard: (props) => <FlowCard {...props} />,
  DeliveryInstructionsCard: (props) => <DeliveryInstructionsCard {...props} />,
  UserDetailsCard: (props) => <UserDetailsCard {...props} />,
  BasketCard: (props) => <BasketCard {...props} />,
  ActivitySliderCard: (props) => <ActivitySliderCard {...props} />,
  RecommendAFriendCard: (props) => <RecommendAFriendCard {...props} />,
  DetailsConfirmCard: (props) => <DetailsConfirmCard {...props} />,
  OrderDeliveredCard: (props) => <OrderDeliveredCard {...props} />
};

export default CARD_REGISTER;



// WEBPACK FOOTER //
// ./src/cards/index.js